import news1 from "../assets/logo1.jpeg"
import builder from "../assets/logo1.png"
import vappywear2 from "../assets/vappywear2.png"
import comprosser from "../assets/vappy-logo.svg"
import tusharImg from "../assets/tushar.jpeg"
import harshImg from "../assets/harsh.jpeg"
import hrythumImg from "../assets/hrythum.jpeg"
import showyabImg from "../assets/showyab.jpeg"
import arjunImg from "../assets/arjun.png"
export const navigationLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Portfolio', path: '/portfolio' },
  { label: 'Businesses', path: '/businesses' },
  { label: 'Blog', path: '/blog' },
  { label: 'Quotes', path: '/quotes' },
  { label: 'Team', path: '/team' },
  { label: 'Contact', path: '/contact' }
];

export const socialLinks = [
  // { label: 'LinkedIn', value: '@arjunsharma', href: '#' },
  { label: 'GitHub', value: 'github.com/arjun', href: 'https://github.com/arjunsharmazz' },
  { label: 'Instagram', value: '@vappytech', href: 'https://www.instagram.com/vappytech?utm_source=qr&igsh=dzg2NHpjNGs3aDd0' },
  { label: 'YouTube', value: 'Udann Learning', href: 'https://youtube.com/@vaappytech?si=d8WzLvcBVUgRgtkj' }
];

export const heroStats = [
  { value: '8+', label: 'Projects Delivered' },
  { value: '150+', label: 'Students Taught' },
  { value: '5+', label: 'Years Experience' }
];

export const featuredProjects = [
  {
    title: 'VappyShop',
    category: 'Founder Build',
    summary: 'My own founder-built ecommerce platform for VappyShop, live on the web and positioned as a real product business.',
    stack: ['React', 'Node.js', 'Ecommerce'],
    accent: 'gold',
    image:
      'https://www.vappyshop.com/static/media/512x512%20px.b66372c34e6d3462ca0f.png',
    alt: 'Premium ecommerce workspace with packaging and shopping visuals',
    eyebrow: 'Own Startup Store'
  },
  {
    title: 'LaathSaab News Website',
    category: 'Client Work',
    summary: 'A client news platform built for structured publishing, readable content browsing, and a stronger digital media presence.',
    stack: ['React', 'News Website', 'Responsive UI'],
    accent: 'steel',
    image: news1,
    alt: 'Editorial desk with newspaper and media storytelling visuals',
    eyebrow: 'Editorial Platform'
  },
  {
    title: 'FX',
    category: 'Web App',
    summary: 'A live web app project deployed on Vercel that highlights product-style interface work beyond standard service websites.',
    stack: ['React', 'Web App', 'Vercel'],
    accent: 'gold',
    image:
      'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkn-in0FUJCfacmch_8E1XVgUhiJ3uUyLG3w&s',
    alt: 'Financial dashboard screens with charts and premium interface lighting',
    eyebrow: 'Live Product Experience'
  }
];

export const journeyTimeline = [
  {
    year: '2021',
    title: 'Started Web Development',
    description: 'Began the journey in web development by learning, building, and improving practical frontend and full-stack skills.'
  },
  {
    year: '2022',
    title: 'Started Education at Learning Point Coaching Center',
    description: 'Entered the education space by starting teaching and helping students learn computer basics and practical digital skills.'
  },
  {
    year: '2023',
    title: 'Started Udann Computer Coaching Center',
    description: 'Launched Udann Computer Coaching Center to provide practical learning in programming, web development, and technology.'
  },
  {
    year: '2024',
    title: 'Started VappyTech',
    description: 'Started VappyTech to build websites, digital products, and branded online experiences with a founder mindset.'
  },
  {
    year: '2025',
    title: 'Started VappyShop Startup in December',
    description: 'In December 2025, started building VappyShop as an independent startup with a focus on real products and long-term growth.'
  },
  {
    year: '2026',
    title: 'Working on Own Robotics Products and AI',
    description: 'Began working on self-built robotics products and an in-house AI direction. This work is currently in progress and not public yet.'
  }
];

export const skillBars = [
  { label: 'MERN Stack Development', value: 96 },
  { label: 'UI/UX Understanding', value: 90 },
  { label: 'Teaching Programming', value: 94 },
  { label: 'Robotics Prototyping', value: 86 }
];

export const techStack = [
  {
    title: 'MongoDB',
    category: 'Database Systems',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT2ZYtHv2OLXmthRPbkmENZRXuqBVDwlsrZ1A&s',
    alt: 'Server room representing database infrastructure'
  },
  {
    title: 'Express',
    category: 'Backend Routing',
    image: 'https://blog.logrocket.com/wp-content/uploads/2020/12/express-middlewares-complete-guide.png',
    alt: 'Developer workspace representing backend engineering'
  },
  {
    title: 'React',
    category: 'Frontend Interfaces',
    image: 'https://miro.medium.com/v2/resize:fit:1400/0*y6IcBe5J1AdALzXw.png',
    alt: 'Code editor on screen representing React development'
  },
  {
    title: 'Node.js',
    category: 'Runtime Services',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQ-sdRIvQxSBfArITwaURCNiCo1hu9Vf_uEQ&s',
    alt: 'Team coding session representing Node.js application work'
  },
  {
    title: 'JavaScript',
    category: 'Core Language',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS7hNih5NiwDd-y442BTBIIRkr_JDHuuipr9A&s',
    alt: 'Laptop and source code representing JavaScript development'
  },
  {
    title: 'Figma',
    category: 'Product Design',
    image: 'https://play-lh.googleusercontent.com/hoVBnPBRehmXsCqESLXRH2E3OTxklkwKZlb1psn7imm0VUSobn2nevS9RRFWb9GM4-o',
    alt: 'Design desk with screen and notebooks representing UI design'
  },
  {
    title: 'Arduino',
    category: 'Hardware Prototyping',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR89KyPtJcbrW1n8AMcMOYnlUJAfC1kMCtcgA&s',
    alt: 'Electronic components representing Arduino prototyping'
  },
  {
    title: 'ESP32',
    category: 'IoT Systems',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQpV-4zJ578BXOSk6d9XqgpN7LEz3VklEib1w&s',
    alt: 'Microcontroller board representing ESP32 based projects'
  },
  {
    title: 'Raspberry Pi',
    category: 'Embedded Projects',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS54FIkw1FtwUfMJ8YTMmgRkuQSglMypF3bLA&s',
    alt: 'Embedded computing setup representing Raspberry Pi experimentation'
  },
  {
    title: 'REST APIs',
    category: 'Connected Services',
    image: 'https://cdn.prod.website-files.com/62d9b9c78f111f03f778e150/68624ec9dc394e09ab806d0b_rest%20api%20image.png',
    alt: 'Digital dashboard representing API integrations and data flow'
  },
  {
    title: 'UI Systems',
    category: 'Design Consistency',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS6iv1rYbbhr9pPEuBdToAe-6xKUkErtRQ6cg&s',
    alt: 'Creative workspace representing design systems and interface planning'
  },
  {
    title: 'Teaching Labs',
    category: 'Hands-On Learning',
    image: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&w=900&q=80',
    alt: 'Students collaborating in a learning lab environment'
  }
];

export const portfolioFilters = ['All', 'Founder Build', 'Client Work', 'Web Apps'];

export const portfolioProjects = [
  {
    title: 'VappyShop',
    category: 'Founder Build',
    imageLabel: 'VappyShop',
    image: 'https://www.vappyshop.com/static/media/512x512%20px.b66372c34e6d3462ca0f.png',
    imageAlt: 'Ecommerce product workspace with laptop and shopping package elements',
    summary: 'My own founder-led ecommerce platform that I built for VappyShop with a full branded web experience.',
    stack: ['React', 'Node.js', 'Ecommerce', 'Founder Product'],
    details: 'VappyShop is a self-built founder project focused on delivering a real online store experience with brand identity, product presentation, and scalable frontend structure.',
    result: 'Live on the web at vappyshop.com and also available on the Play Store.',
    liveUrl: 'https://www.vappyshop.com/',
    liveLabel: 'Visit Website',
    availability: ['Web', 'Play Store'],
    theme: 'gold'
  },
  {
    title: 'LaathSaab News Website',
    category: 'Client Work',
    imageLabel: 'News Platform',
    image: news1,
    imageAlt: 'Editorial workspace with newspapers and digital publishing context',
    summary: 'A client news website built for publishing updates, content categories, and a clean reading-focused experience.',
    stack: ['React', 'News Website', 'Responsive UI'],
    details: 'Built for LaathSaab as a content-driven client project with a clear layout, readable sections, and structured browsing for news content.',
    result: 'Gives the client a polished digital publication presence with accessible content delivery.',
    liveUrl: 'https://www.laathsaab.com/',
    liveLabel: 'Open Website',
    availability: ['Web'],
    theme: 'steel'
  },
  {
    title: 'VappyBuilder',
    category: 'Web Apps',
    imageLabel: 'Resume Builder',
    image: builder,
    imageAlt: 'Resume and CV builder interface with clean document creation tools',
    summary: 'A practical web app for creating resumes, CVs, and polished profile documents with a simple guided flow.',
    stack: ['React', 'Resume Builder', 'Web App'],
    details: 'VappyBuilder is designed to help users quickly generate professional resumes and CV layouts through an easy-to-use online builder experience.',
    result: 'Makes resume and CV creation faster for students, job seekers, and professionals who need clean document output.',
    liveUrl: 'https://vappybuilder.vercel.app/',
    liveLabel: 'Launch App',
    availability: ['Web App'],
    theme: 'gold'
  },
  {
    title: 'VappyCompressor',
    category: 'Web Apps',
    imageLabel: 'Image Tool',
    image: comprosser,
    imageAlt: 'Image compression dashboard with upload and optimized export actions',
    summary: 'A utility web app focused on compressing images quickly while keeping the workflow simple and accessible.',
    stack: ['React', 'Image Compressor', 'Utility App'],
    details: 'VappyCompressor is built as a focused web utility for reducing image file sizes, improving sharing speed, and supporting lightweight digital workflows.',
    result: 'Provides a fast tool-based experience for compressing images without needing heavy desktop software.',
    liveUrl: 'https://vappycompressor.vercel.app/',
    liveLabel: 'Open Tool',
    availability: ['Web App'],
    theme: 'steel'
  },
  {
    title: 'VappyFashion',
    category: 'Founder Build',
    imageLabel: 'Fashion Store',
    image: vappywear2,
    imageAlt: 'Modern online clothing storefront with fashion product browsing',
    summary: 'A fashion ecommerce website concept focused on selling clothes with a branded shopping experience and clear product discovery.',
    stack: ['React', 'Fashion Ecommerce', 'Founder Product'],
    details: 'VappyFashion extends the Vappy brand into clothing commerce with a storefront experience centered on product presentation, category browsing, and conversion-ready layouts.',
    result: 'Expands the portfolio with a niche ecommerce direction for apparel-focused online selling.',
    liveUrl: 'https://vappywear.vercel.app/',
    liveLabel: 'Visit Store',
    availability: ['Web'],
    theme: 'gold'
  },
  {
    title: 'FX',
    category: 'Web Apps',
    imageLabel: 'Fintech UI',
    image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRkn-in0FUJCfacmch_8E1XVgUhiJ3uUyLG3w&s',
    imageAlt: 'Fintech trading interface with charts on illuminated screens',
    summary: 'A web application project deployed on Vercel with a focused product interface and fast access flow.',
    stack: ['React', 'Web App', 'Vercel'],
    details: 'PayKuberFX is presented as a live web app build with product-style layout, responsive structure, and a clean interface for online usage.',
    result: 'Showcases product-building ability beyond brochure websites with a live app experience.',
    liveUrl: 'https://paykuberfx.vercel.app/',
    liveLabel: 'Launch App',
    availability: ['Web App'],
    theme: 'gold'
  },
  {
    title: 'ArogyaRahita',
    category: 'Client Work',
    imageLabel: 'Healthcare Site',
    image: 'https://arogyarahita.vercel.app/static/media/arogyamlogo.7055f66df40a69bd23f1.png',
    imageAlt: 'Healthcare consultation desk with tablet and medical context',
    summary: 'A client healthcare-focused website created with a clear service presentation and trust-first layout.',
    stack: ['React', 'Healthcare Website', 'Responsive Design'],
    details: 'Developed for ArogyaRahita with an emphasis on clarity, accessibility, and a professional service-oriented user experience.',
    result: 'Improves digital trust and gives the client a clean online identity for healthcare-oriented communication.',
    liveUrl: 'https://arogyarahita.vercel.app/',
    liveLabel: 'Open Website',
    availability: ['Web'],
    theme: 'steel'
  }
];

export const businessContent = {
  vappyTech: {
    title: 'VappyTech',
    subtitle: 'A digital service brand where we build websites, apps, design systems, and visual content for modern businesses.',
    cta: 'Work With VappyTech',
    services: [
      {
        iconType: 'web',
        title: 'Web Development',
        subtitle: 'Modern, Fast & SEO Friendly Websites',
        tools: [
          'React.js',
          'Next.js',
          'Node.js',
          'Express.js',
          'MongoDB / MySQL',
          'Tailwind CSS',
          'REST API Integration',
          'Admin Dashboard',
          'E-Commerce',
          'SEO Optimization'
        ]
      },
      {
        iconType: 'app',
        title: 'App Development',
        subtitle: 'Android & iOS Applications',
        tools: [
          'React Native',
          'Flutter',
          'Android (Java/Kotlin)',
          'Firebase',
          'Node.js Backend',
          'Push Notifications',
          'Payment Gateway',
          'Maps & GPS',
          'API Integration',
          'Play Store Publishing'
        ]
      },
      {
        iconType: 'uiux',
        title: 'UI/UX Designing',
        subtitle: 'Beautiful & User-Centered Interfaces',
        tools: [
          'Figma',
          'Adobe XD',
          'Wireframing',
          'Prototyping',
          'Design System',
          'Responsive Design',
          'Dashboard UI',
          'Mobile App UI',
          'Website UI',
          'User Experience Research'
        ]
      },
      {
        iconType: 'logo',
        title: 'Logo Making',
        subtitle: 'Professional Brand Identity',
        tools: [
          'Minimal Logo',
          'Modern Logo',
          '3D Logo',
          'Mascot Logo',
          'Luxury Logo',
          'Business Branding',
          'Brand Guidelines',
          'Vector Files',
          'Social Media Kit',
          'Print Ready Files'
        ]
      },
      {
        iconType: 'video',
        title: 'Video Editing',
        subtitle: 'High-Quality Motion Content',
        tools: [
          'Adobe Premiere Pro',
          'After Effects',
          'Motion Graphics',
          'Reels & Shorts',
          'YouTube Editing',
          'Podcast Editing',
          'Color Grading',
          'VFX',
          'Map Animation',
          'Thumbnail Design'
        ]
      },
      {
        iconType: 'poster',
        title: 'Poster Making',
        subtitle: 'Creative Marketing Designs',
        tools: [
          'Social Media Posts',
          'Business Posters',
          'Event Posters',
          'Festival Creatives',
          'Product Ads',
          'Banner Design',
          'Flyer Design',
          'Brochure Design',
          'Canva Designs',
          'Print Ready Files'
        ]
      }
    ]
  },
  vappyShop: {
    title: 'VappyShop',
    subtitle: 'Our own startup brand focused on building a real ecommerce business and product-driven shopping experience.',
    highlights: ['Founder-built startup', 'Live website presence', 'Growing product brand', 'Available on web and Play Store'],
    cta: 'Visit VappyShop',
    href: 'https://www.vappyshop.com/'
  },
  robotics: {
    title: 'Self-Made Robots',
    subtitle: 'A future-focused in-house robotics initiative where we will build our own products step by step.',
    focus: ['Custom robotics products', 'Prototype hardware systems', 'Long-term product R&D', 'Currently in progress and not public yet'],
    cta: 'Contact for Updates'
  }
};

export const blogCategories = ['Programming', 'Robotics', 'Books'];

export const blogPosts = [
  {
    category: 'Programming',
    title: 'How Premium UI Builds Trust Before the First Call',
    excerpt: 'A breakdown of spacing, surface design, and conversion hierarchy that makes a portfolio feel instantly more credible.',
    meta: '6 min read'
  },
  {
    category: 'Robotics',
    title: 'Project-Based Robotics Learning Works Faster Than Theory-Only Classes',
    excerpt: 'Why Arduino, ESP32, and Raspberry Pi become more exciting when students build from day one.',
    meta: '7 min read'
  },
  {
    category: 'Books',
    title: 'Three Books That Improved How I Build Products and Teach',
    excerpt: 'Ideas on product thinking, clarity, and design discipline that directly shaped my work.',
    meta: '4 min read'
  }
];

export const quoteCollection = [
  { category: 'motivation', text: 'Build with precision, teach with clarity, and grow with vision.' },
  { category: 'coding', text: 'The strongest interfaces remove doubt before asking for action.' },
  { category: 'life', text: 'Consistency makes premium work look effortless.' },
  { category: 'future tech', text: 'Robotics turns imagination into something you can switch on.' }
];

export const teamMembers = [
  {
    name: 'Tushar',
    role: 'Frontend & Backend Full Stack Developer',
    skills: ['Frontend', 'Backend', 'Full Stack', 'AI Website Developer'],
    initials: 'T',
    image: tusharImg,
    imageAlt: 'Tushar full stack developer portrait'
  },
  {
    name: 'Harsh',
    role: 'Designer & Motion Editor',
    skills: ['UI/UX', 'Video Editing', 'Animation', 'After Effects', 'Adobe', 'Corel'],
    initials: 'H',
    image: harshImg,
    imageAlt: 'Harsh designer and animator portrait'
  },
  {
    name: 'Hrythum Raj Sharma',
    role: 'AI Photo, Script & Video Specialist, UI/UX Designer',
    skills: ['AI Photos', 'Script Writing', 'Video Production', 'UI/UX', 'Client Collaboration'],
    initials: 'HR',
    image: hrythumImg,
    imageAlt: 'Hrythum Raj Sharma AI photos and video specialist portrait'
  },
  {
    name: 'Shoyab',
    role: 'UI/UX & AI Video Specialist',
    skills: ['UI/UX', 'AI Videos', 'Client Collaboration', 'Frontend'],
    initials: 'S',
    image: showyabImg,
    imageAlt: 'Shoyab UI/UX specialist portrait'
  },
  {
    name: 'Arjun Sharma',
    role: 'Full Stack & Blockchain Developer',
    skills: ['Frontend', 'Backend', 'Full Stack', 'Blockchain', 'AI'],
    initials: 'AS',
    image: arjunImg,
    imageAlt: 'Arjun Sharma full stack developer portrait'
  }
];